import { createFileRoute } from '@tanstack/react-router'

import { Card, CardContent } from '@/components/ui/card'
import { InvoiceSettingsForm } from '@/components/invoices/invoice-settings-form'
import { MisaAccountCard } from '@/components/invoices/misa-account-card'
import { useAuth } from '@/hooks/use-auth'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute('/_app/_authed/_sidebar/settings/invoice')(
    {
        component: InvoiceSettingsPage,
    },
)

export function InvoiceSettingsPage() {
    const { hasPermission, arePermissionsLoaded } = useAuth()
    if (!arePermissionsLoaded) {
        return (
            <div className="p-4 text-sm text-muted-foreground md:p-6">
                {m.common_loading()}
            </div>
        )
    }
    if (!hasPermission('invoices.read')) {
        if (!hasPermission('invoices.export')) return <ForbiddenState />
        return (
            <div className="max-w-2xl space-y-6 page-pad">
                <h1 className="text-xl font-semibold">
                    {m.invoice_settings_title()}
                </h1>
                <MisaAccountCard />
            </div>
        )
    }
    return <InvoiceSettingsForm />
}

function ForbiddenState() {
    return (
        <Card className="m-4 md:m-6">
            <CardContent className="space-y-2 py-12 text-center">
                <h2 className="text-lg font-semibold">
                    {m.invoice_settings_forbidden_title()}
                </h2>
                <p className="text-sm text-muted-foreground">
                    {m.invoice_settings_forbidden_desc()}
                </p>
            </CardContent>
        </Card>
    )
}
